'use strict';

const { getDependencyClass } = require('../../lib/dependencies.js');

getDependencyClass('phoenix-page').then((pageClass) => {
    /**
     * EmbedcodeEmbed
     *
     * This web component will lazy-load 'embedcode' embeds. Once an
     * embed is scrolled into view, the embed is rendered into a friendly
     * iframe and connected to resize properly to contain whatever content
     * it holds.
     *
     * @example
     *     <figure>
     *         <phoenix-embedcode-embed>
     *             <script type="text/plain">[embed content]</script>
     *         </phoenix-embedcode-embed>
     *     </figure>
     */
    class EmbedcodeEmbed extends pageClass.PhoenixElement {
        connectedCallback() {
            super.connectedCallback();

            let promises = [
                // make sure the subtree is ready
                this.waitForElement('script', { untilDomReady: true }),
                this.canRender(),
                pageClass.util.userHasPremium(),
            ];

            Promise.all(promises).then(([script, canRender, userHasPremium]) => {
                if (canRender) {
                    // Cascade through GDPR, lazy load, and render embed.
                    this.observeFirstIntersection();

                    if (userHasPremium) {
                        this.classList.add('is-premium-width');
                    }
                } else {
                    // Make CSS show the fallback markup
                    this.classList.add('mm-custom-element--fallback');
                }
            });
        }

        onFirstIntersection() {
            var script = this.querySelector('script');
            if (!script) {
                return;
            }

            var embedCode = script.innerText;
            embedCode = embedCode
                .replace(/&lt;/g, '<')
                .replace(/&gt;/g, '>')
                .replace(/&quot;/g, '"')
                .replace(/&amp;/g, '&');
            this.removeChild(script);

            // Create a sourceless iframe that will hold the embed content.
            var iframe = document.createElement('iframe');
            iframe.className = 'm-embed--frame';
            iframe.setAttribute('width', '100%');
            iframe.setAttribute('frameborder', '0');
            this.appendChild(iframe);

            // render embed
            var sizerId = '_say_sizer';
            var html = `<!DOCTYPE html><html>
                    <head></head>
                    <body
                        style="margin:0;padding:0;position:absolute;width:100%;text-align:center;">
                        <iframe id="${sizerId}" width="0" frameborder="0"
                            style="height:100%;width:100%;
                            position:absolute;top:0;bottom:0;opacity:0;right:0;left:0;z-index:-1">
                        </iframe>
                        ${embedCode}
                    </body>
                </html>`;

            // Some code to place the embed into the iframe and handle synchronization of the height of the
            // inner embed document and the host iframe that contains it.
            var innerDoc = iframe.contentWindow.document;
            innerDoc.open();
            innerDoc.write(html);
            innerDoc.close();

            var sizer = innerDoc.getElementById(sizerId);

            var resize = function () {
                var sizeDimensions = sizer.getClientRects()[0];
                if (sizeDimensions) {
                    var sizerWidth = sizeDimensions.width;
                    var sizerHeight = sizeDimensions.height;

                    if (sizerHeight) {
                        iframe.style.height = sizerHeight + 'px';
                    }

                    if (sizerWidth) {
                        iframe.style.width = sizerWidth + 'px';
                    }
                }
            };
            iframe.contentWindow.addEventListener('load', resize, false);
            sizer.contentWindow.addEventListener('resize', resize, false);
            resize();
        }
    }
    window.customElements.define('phoenix-embedcode-embed', EmbedcodeEmbed);
});
